interface EnvConfig {
  NODE_ENV?: string;
  API_PATH?: string;
  ADMIN_API_PATH?: string;
  MEDIA_API_PATH?: string;
  PUBLIC_URL?: string;
  APP_DSN_SENTRY?: string;
  SOCKET_PATH?: string;
  [key: string]: any;
}

export function getEnv(): EnvConfig {
  if (typeof window === 'undefined') {
    return process?.env;
  }

  const envs = (window as any)?.ENV ?? process?.env;
  return {
    NODE_ENV: envs?.NODE_ENV,
    API_PATH: envs?.API_PATH,
    ADMIN_API_PATH: envs?.ADMIN_API_PATH,
    MEDIA_API_PATH: envs?.MEDIA_API_PATH,
    PUBLIC_URL: envs?.PUBLIC_URL,
    APP_DSN_SENTRY: envs?.APP_DSN_SENTRY,
    SOCKET_PATH: envs?.SOCKET_PATH,
  };
}
